/**
 * IRSP Submissions Vuex Mutations
 */
export default {
  /**
   * Set pagination state
   * @param {Object} state - Vuex state
   * @param {Object} data - Pagination data
   */
  SET_PAGINATION(state, data) {
    state.pagination = {
      ...state.pagination,
      ...data,
    }
  },

  /**
   * Set submissions list
   * @param {Object} state - Vuex state
   * @param {Array} submissions - Array of IRSP submissions
   */
  SET_SUBMISSIONS(state, submissions) {
    state.submissions = submissions || []
  },

  /**
   * Update a single submission in the list
   * Used after refresh status to update without re-fetching entire list
   * @param {Object} state - Vuex state
   * @param {Object} submission - Updated submission data
   */
  UPDATE_SUBMISSION(state, submission) {
    if (!submission || !submission.uuid) return
    
    const index = state.submissions.findIndex((s) => s.uuid === submission.uuid)
    if (index !== -1) {
      state.submissions.splice(index, 1, submission)
    }
  },

  /**
   * Add a new submission to the top of the list
   * Used after creating a new submission
   * @param {Object} state - Vuex state
   * @param {Object} submission - New submission data
   */
  ADD_SUBMISSION(state, submission) {
    if (!submission) return
    state.submissions.unshift(submission)
    state.pagination.totalItem += 1
  },

  /**
   * Set loading state
   * @param {Object} state - Vuex state
   * @param {boolean} isLoading - Loading state
   */
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },

  /**
   * Set refreshing state (for status refresh operations)
   * @param {Object} state - Vuex state
   * @param {boolean} isRefreshing - Refreshing state
   */
  SET_REFRESHING(state, isRefreshing) {
    state.isRefreshing = isRefreshing
  },

  /**
   * Set error state
   * @param {Object} state - Vuex state
   * @param {string|null} error - Error message or null to clear
   */
  SET_ERROR(state, error) {
    state.error = error
  },

  /**
   * Clear error state
   * @param {Object} state - Vuex state
   */
  CLEAR_ERROR(state) {
    state.error = null
  },
}
